// extracted by mini-css-extract-plugin
export default {"field":"Textarea_field__IFrAr","label":"Textarea_label__HeQh1","textarea":"Textarea_textarea__SsB7f","errorState":"Textarea_errorState__svdU1","error":"Textarea_error__78DZq"};